import styles from "./Checkoutstepper.module.css";

const CheckoutStepper = ({ currentStep }) => {
  const steps = [
    {
      number: 1,
      label: "Delivery",
    },
    {
      number: 2,
      label: "Payment",
    },
  ];

  return (
    <div className={styles.checkoutStepper}>
      {steps.map((step, index) => {
        const isCompleted = currentStep > step.number;
        const isActive = currentStep === step.number;

        return (
          <div key={step.number} className={styles.stepWrapper}>
            <div className={styles.stepItem}>
              <div
                className={`
                  ${styles.stepCircle}
                  ${isCompleted ? styles.completed : ""}
                  ${isActive ? styles.active : ""}
                `}
              >
                {isCompleted ? "✓" : step.number}
              </div>

              <span
                className={`
                  ${styles.stepLabel}
                  ${isCompleted ? styles.completedLabel : ""}
                  ${isActive ? styles.activeLabel : ""}
                `}
              >
                {step.label}
              </span>
            </div>

            {index < steps.length - 1 && (
              <div
                className={`
                  ${styles.stepLine}
                  ${isCompleted ? styles.completedLine : ""}
                `}
              />
            )}
          </div>
        );
      })}
    </div>
  );
};

export default CheckoutStepper;